import { CountriesApiService } from '../../common/services/countries.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    items: [],
    defaultCountry: null,
  },
  getters: {
    getAllCountries: state => state.items,
    getAllCountriesForSelect: state => state.items.map(country => ({ text: country.name, value: country.id })),
    getCountry: state => id => state.items.find(curr => curr.id === id),
  },

  mutations: {
    SET_ITEMS(state, countries) {
      state.items = countries;
    },
    SET_DEFAULT_COUNTRY(state, country) {
      state.defaultCountry = country;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },

  actions: {
    fetchAllCountries({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return CountriesApiService.getAll()
        .then(response => {
          const countries = response.getItems();
          const defaultCountry = countries.find(curr => curr.isDefault);

          commit('SET_ITEMS', countries);
          commit('SET_DEFAULT_COUNTRY', defaultCountry);
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
